import React from 'react';
import { Link } from 'react-router-dom';
import './Logo.css';

/**
 * Logo component
 *
 * Props:
 *  to          string   — link destination (default "/")
 *  image       string   — path to logo image (optional)
 *  imageAlt    string   — alt text for image
 *  title       string   — main brand name e.g. "AccuGen"
 *  titleAccent string   — accented suffix e.g. ".ai" or "RAH"
 *  tagline     string   — subtitle below the title
 *  onClick     function — optional click handler
 */
export default function Logo({
  to = '/',
  image,
  imageAlt = 'Logo',
  title = 'AccuGen',
  titleAccent = '.ai',
  tagline = 'Where AI Meets Reality',
  onClick,
}) {
  return (
    <Link to={to} className="brand-logo" onClick={onClick} aria-label={`${title}${titleAccent} — ${tagline}`}>
      {/* Logo image */}
      {image && (
        <div className="brand-logo__img-wrap">
          <img src={image} alt={imageAlt} className="brand-logo__img" />
        </div>
      )}

      {/* Text block */}
      <div className="brand-logo__text">
        <div className="brand-logo__title">
          <span className="brand-logo__name">{title}</span>
          <span className="brand-logo__accent">{titleAccent}</span>
        </div>
        {tagline && (
          <div className="brand-logo__tagline">{tagline}</div>
        )}
      </div>
    </Link>
  );
}
